import React, { useContext } from "react";
import { Redirect, useLocation } from "react-router-dom";

import { AuthContext } from "../../contexts/authContext";

const CHANGE_PASSWORD_PATH = "/mis/change-password";

const MustChangePasswordGuard = ({ children }) => {
  const { mustChangePassword } = useContext(AuthContext);
  const location = useLocation();

  if (mustChangePassword && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Redirect to={CHANGE_PASSWORD_PATH} />;
  }

  return children;
};

export default MustChangePasswordGuard;
